//modal de pais
$(document).ready(function () {
    //si existe el elemento hace la funcionalidad de las banderas si no pues no :) iordaz
    if ($("#brand-modal").length > 0) {

        checkCountry();

        function checkCountry() {
            let country = Cookies.get('country');
            if (country !== 'MX' && country !== 'ES' && country !== 'AR') {
                $('#brand-modal').modal('toggle')
            } else if (country === 'ES') {
                // mostrar mensaje solo una vez
                checkSuscribirseAlert();
            }
        }

        const mexico = document.getElementById('brand-mx'),
            espania = document.getElementById('brand-es');


        mexico.addEventListener('click', (e) => {
            e.preventDefault();
            changeModal('MX');
        });
        espania.addEventListener('click', (e) => {
            e.preventDefault();
            changeModal('ES');
        });

        /*argentina.addEventListener('click', (e) => {
            e.preventDefault();
            changeModal('AR');
        });*/

        //Select (combo) country en el menu
        const select = document.querySelector('#select');
        const opciones = document.querySelector('#opciones');
        const contenidoSelect = document.querySelector('#select .contenido-select');
        const hiddenInput = document.querySelector('#inputSelect');

        document.querySelectorAll('#opciones > .opcion').forEach((opcion) => {
            opcion.addEventListener('click', (e) => {
                e.preventDefault();
                contenidoSelect.innerHTML = e.currentTarget.innerHTML;
                select.classList.toggle('active');
                opciones.classList.toggle('active');
                //let value = e.currentTarget.querySelector('.titulo').innerText
                let value = change_flangs(e.currentTarget.querySelector('.titulo').innerText);
                hiddenInput.value = value;
                changeSelect(value);
            });
        });

        select.addEventListener('click', () => {
            select.classList.toggle('active');
            opciones.classList.toggle('active');
        });
    }

    function changeSelect(value) {
        Cookies.set('country', value), {expires: 7};
        $.ajax({
            url: window.location.origin + "/change/combox/language",
            type: "post",
            data: {
                language: value
            },
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (data) {
                window.location.reload();
            },
            error: function (errors, xhr, status,) {
                window.location.reload()
            }
        })
    }

    function changeModal(value) {
        Cookies.set('country', value), {expires: 7};
        $.ajax({
            url: window.location.origin + "/change/modal/language",
            type: "post",
            data: {
                language: value
            },
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (data) {
                window.location.reload();
            },
            error: function (errors, xhr, status,) {
                window.location.reload();
                var errors_ = errors.responseJSON.errors;
                console.log(errors_)
            }
        })
    }

    function change_flangs(value) {

        switch (value) {
            case 'MEX':
                value = 'MX';
                break;
            case 'ESP':
                value = 'ES';
                break;
            default:
                value = 'MX';
                break;
        }

        return value;
    }

    function checkSuscribirseAlert() {
        if (!Cookies.get('suscribirse')) {
            $('#subscribe-modal-es').modal('show');
            Cookies.set('suscribirse', 'show', { expires: 7 });
        }
    }

});


